import React from 'react'
import Map from './Map'
import EmailForm from './EmailForm'
import BusinessHours from './BusinessHours'
import logo from '../components/assets/images/logo.png'


const Footer = () => {
  return (
    <div>
    <div className='footer'>
        <BusinessHours />
        <EmailForm />
        <Map />
    </div>
    <hr></hr>
    <div className='footer-logo'>
        <img src={logo} alt='MW Car and Commercial logo' />
    </div>
    </div>
  )
}

export default Footer